/* ──────────────────────────────────────────────────────────────
   src/api/bonus.ts
   Endpoints REST relacionados con los bonus A365
   ────────────────────────────────────────────────────────────── */
import axios from './axios';

/* ═════════════ 1. Toggle checkpoint ═════════════ */
/** Crea / elimina (toggle) el checkpoint de una reserva */
export async function toggleBonusCheckpoint(reservaId: number, alumnoId?: number) {
  await axios.patch(`/bonus-a365/checkpoint/${reservaId}`, undefined, {
    params: alumnoId != null ? { alumnoId } : undefined,
  });
}

/* ═════════════ 2. Histórico checkpoints ═════════════ */
export type BonusCheckpointRow = {
  alumnoId: number;
  asignaturaId: number;
  reservaId: number;
  fecha: string; // YYYY-MM-DD  – fecha de la clase
  alumno: string;
  asignatura: string;
  marcadoPor: string;
  fechaMarcado: string; // ISO string timestamp
};

/**
 * Devuelve todos los checkpoints del profesor en el rango
 * `[desde, hasta]` (ambos inclusive)
 */
export async function getBonusCheckpoints(profesorId: number, desde: string, hasta: string) {
  const { data } = await axios.get<BonusCheckpointRow[]>(`/bonus-a365/checkpoints/${profesorId}`, {
    params: { desde, hasta },
  });
  return data;
}
